// extracted by mini-css-extract-plugin
export default {"main":"HomeSection_main__VWUqJ","home_container":"HomeSection_home_container__G6IYw"};